export const TRANSACTION_TYPES = Object.freeze({
  INCOME: 'Receitas',
  EXPENSE: 'Despesas',
});

export const FINANCIAL_SCHEMA_VERSION = 2;

export const TRANSACTION_STATUS = Object.freeze({
  RECEIVED: 'Recebido',
  PAID: 'Pago',
  PENDING: 'Pendente',
});

export const TRANSACTION_STATE = Object.freeze({
  REALIZED: 'realized',
  PLANNED: 'planned',
});

export const CATEGORY_TYPES = Object.freeze({
  INCOME: 'income',
  EXPENSE: 'expense',
  BOTH: 'both',
});

const category = (name, type = CATEGORY_TYPES.EXPENSE) => Object.freeze({
  id: `default:${name}`,
  name,
  type,
  active: true,
  source: 'default',
});

export const DEFAULT_FINANCIAL_CATEGORIES = Object.freeze([
  category('Alimentação', CATEGORY_TYPES.BOTH),
  category('Supermercado'),
  category('Restaurantes e Delivery'),
  category('Transporte', CATEGORY_TYPES.BOTH),
  category('Veículo', CATEGORY_TYPES.BOTH),
  category('Combustível'),
  category('Manutenção do Veículo'),
  category('Estacionamento e Pedágios'),
  category('Moradia', CATEGORY_TYPES.BOTH),
  category('Energia'),
  category('Água'),
  category('Internet'),
  category('Telefone'),
  category('Condomínio'),
  category('Aluguel'),
  category('Financiamento'),
  category('Casa e Manutenção'),
  category('Educação'),
  category('Saúde'),
  category('Farmácia'),
  category('Academia'),
  category('Cuidados Pessoais'),
  category('Beleza'),
  category('Filhos'),
  category('Pets'),
  category('Lazer'),
  category('Entretenimento'),
  category('Eventos'),
  category('Viagens'),
  category('Assinaturas e Mensalidades'),
  category('Roupas e acessórios'),
  category('Compras'),
  category('Eletrônicos'),
  category('Tecnologia'),
  category('Presentes e doações'),
  category('Dívidas e Empréstimos', CATEGORY_TYPES.BOTH),
  category('Seguros e Taxas'),
  category('Impostos'),
  category('Tarifas Bancárias'),
  category('Investimentos', CATEGORY_TYPES.BOTH),
  category('Poupança', CATEGORY_TYPES.BOTH),
  category('Previdência', CATEGORY_TYPES.BOTH),
  category('Reserva de Emergência', CATEGORY_TYPES.BOTH),
  category('Trabalho', CATEGORY_TYPES.BOTH),
  category('Serviços', CATEGORY_TYPES.BOTH),
  category('Salário', CATEGORY_TYPES.INCOME),
  category('Renda extra', CATEGORY_TYPES.INCOME),
  category('Reembolsos', CATEGORY_TYPES.INCOME),
  category('Rendimentos', CATEGORY_TYPES.INCOME),
  category('Outros', CATEGORY_TYPES.BOTH),
]);

export const FINANCIAL_CATEGORIES = Object.freeze(
  DEFAULT_FINANCIAL_CATEGORIES.map((item) => item.name)
);

export const isValidTransactionType = (type) =>
  type === TRANSACTION_TYPES.INCOME ||
  type === TRANSACTION_TYPES.EXPENSE;

export const getValidStatusesForType = (type) => {
  if (type === TRANSACTION_TYPES.INCOME) {
    return [
      TRANSACTION_STATUS.RECEIVED,
      TRANSACTION_STATUS.PENDING,
    ];
  }

  if (type === TRANSACTION_TYPES.EXPENSE) {
    return [
      TRANSACTION_STATUS.PAID,
      TRANSACTION_STATUS.PENDING,
    ];
  }

  return [];
};

export const isValidStatusForType = (type, status) =>
  getValidStatusesForType(type).includes(status);

export const getDefaultStatusForType = (type) =>
  type === TRANSACTION_TYPES.INCOME
    ? TRANSACTION_STATUS.RECEIVED
    : TRANSACTION_STATUS.PENDING;

export const getRealizedStatusForType = (type) => {
  if (type === TRANSACTION_TYPES.INCOME) {
    return TRANSACTION_STATUS.RECEIVED;
  }

  if (type === TRANSACTION_TYPES.EXPENSE) {
    return TRANSACTION_STATUS.PAID;
  }

  return null;
};

export const isRealizedStatusForType = (type, status) => {
  const realizedStatus =
    getRealizedStatusForType(type);

  return (
    realizedStatus !== null &&
    status === realizedStatus
  );
};